<template>
  <exo-help-dialog title="Antenna pointing precision">
    <p>
      Antennas often don't emmit/receive the same amount of power in all
      directions (isotropically), but rather usually have one direction where
      the the power is maximized, the boresight (the direction of peak gain).
      The antenna pointing precision is used for measuring the pointing loss
      (also known as the gain roll-off of the antenna) caused by the
      misalignment between the antenna boresight direction and the other
      communicating antenna (transmitter or receiver).
    </p>
    <p>
      In space<strong>studio</strong>, the pointing precision is considered to
      be the constant angle between the respective antenna (transmitter or
      receiver) and the spacecraft-station line. For example, a spacecraft
      receiver antenna with a pointing precision of
      <katex-element expression="\theta = 5°" /> will be considered to have its
      boresight always pointed <katex-element expression="5°" /> away from the
      target ground station.
    </p>
    <tooltipEquationPointingLoss />
    <tooltipEquationEbN0 />
  </exo-help-dialog>
</template>

<script>
import tooltipEquationPointingLoss from './tooltipEquationPointingLoss.vue'
import tooltipEquationEbN0 from './tooltipEquationEbN0.vue'
export default {
  name: 'tooltipPointingPrecision',
  components: {
    tooltipEquationPointingLoss,
    tooltipEquationEbN0
  }
}
</script>
